<div class="reset-password-card" [class.reset-password-card--boxed]="showBorder">
  <div class="reset-password-header">
    <h1>
      {{ !hasCode ? ("loginForm.resetPassword" | translate) : ("resetPassword.title" | translate) }}
    </h1>

    <p>
      {{ !hasCode ? ("resetPassword.emailDescription" | translate) : ("resetPassword.codeDescription" | translate) }}
    </p>
  </div>

  <div class="reset-password-step" [formGroup]="emailForm" *ngIf="!hasCode">
    <!-- Email field -->
    <div class="form-field">
      <label for="reset-email">{{ "userForm.email" | translate }}</label>

      <div class="input-wrapper">
        <lucide-icon name="mail" [size]="19"></lucide-icon>
        <input id="reset-email" formControlName="email" type="email" />
      </div>

      <span class="field-error" *ngIf="emailForm.controls.email.touched && emailForm.controls.email.errors?.['required']">
        {{ "common.required" | translate }}
      </span>

      <span class="field-error" *ngIf="emailForm.controls.email.touched && emailForm.controls.email.errors?.['pattern']">
        {{ "userForm.error.email" | translate }}
      </span>
    </div>
  </div>

  <div class="reset-password-step" [formGroup]="codeForm" *ngIf="hasCode">
    <!-- Code field -->
    <div class="form-field">
      <label for="reset-code">{{ "resetPassword.code" | translate }}</label>

      <div class="input-wrapper">
        <lucide-icon name="key-round" [size]="19"></lucide-icon>
        <input id="reset-code" formControlName="code" />
      </div>
    </div>

    <!-- New password field -->
    <div class="form-field">
      <label for="reset-password">{{ "resetPassword.password" | translate }}</label>

      <div class="input-wrapper">
        <lucide-icon name="lock" [size]="19"></lucide-icon>
        <input id="reset-password" formControlName="password" [type]="showPassword ? 'text' : 'password'" autocomplete="new-password" />

        <button
          type="button"
          class="visibility-button"
          (click)="showPassword = !showPassword"
          [attr.aria-label]="showPassword ? ('password.hide' | translate) : ('password.show' | translate)"
        >
          <lucide-icon [name]="showPassword ? 'eye' : 'eye-off'" [size]="19"></lucide-icon>
        </button>
      </div>

      <span class="field-error" *ngIf="codeForm.controls.password.touched && codeForm.controls.password.errors?.['required']">
        {{ "common.required" | translate }}
      </span>

      <span class="field-error" *ngIf="codeForm.controls.password.touched && codeForm.controls.password.errors?.['pattern']">
        {{ "password.pattern" | translate }}
      </span>
    </div>

    <!-- Confirm new password field -->
    <div class="form-field">
      <label for="reset-confirm-password">{{ "resetPassword.confirmPassword" | translate }}</label>

      <div class="input-wrapper">
        <lucide-icon name="lock-keyhole" [size]="19"></lucide-icon>
        <input id="reset-confirm-password" formControlName="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'" />

        <button
          type="button"
          class="visibility-button"
          (click)="showConfirmPassword = !showConfirmPassword"
          [attr.aria-label]="showConfirmPassword ? ('password.hide' | translate) : ('password.show' | translate)"
        >
          <lucide-icon [name]="showConfirmPassword ? 'eye' : 'eye-off'" [size]="19"></lucide-icon>
        </button>
      </div>

      <span class="field-error" *ngIf="codeForm.controls.confirmPassword.touched && codeForm.controls.confirmPassword.errors?.['required']">
        {{ "common.required" | translate }}
      </span>

      <span class="field-error" *ngIf="codeForm.controls.confirmPassword.touched && codeForm.controls.confirmPassword.errors?.['matching']">
        {{ "password.confirm.mismatch" | translate }}
      </span>
    </div>
  </div>

  <div class="form-actions">
    <button
      type="button"
      class="secondary-button"
      [disabled]="(!hasCode && emailForm.disabled) || (hasCode && codeForm.disabled)"
      (click)="!hasCode ? goBack() : backToEmailStep()"
    >
      {{ !hasCode ? ("button.cancel" | translate) : ("button.back" | translate) }}
    </button>

    <button
      type="button"
      class="primary-button"
      [disabled]="(!hasCode && emailForm.disabled) || (hasCode && codeForm.disabled)"
      (click)="onSubmit()"
    >
      {{ !hasCode ? ("button.send" | translate) : ("button.confirm" | translate) }}
    </button>
  </div>

  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <a *ngIf="!hasCode" class="text-link" tabindex="0" (click)="hasCode = !hasCode">
    {{ "resetPassword.alreadyHave" | translate }}
  </a>
</div>
